export const unsupportedStates = ['CO', 'CT', 'IA', 'MD', 'NH', 'WV', 'VT', 'NV'];

export const unSupportedStatesDPOnly = ['VT', 'WV', 'PR', 'VI'];
